import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-main-navigation-toggle',
  template: `
    @let minimizedVal = minimized();
    @let forceMaximizedVal = forceMaximized();

    <div class="label">
      {{ (forceMaximizedVal ? 'tlc.common.hide' : 'tlc.common.keep_expanded') | translate }}
    </div>

    <div>
      <rt-icon [name]="minimizedVal || !forceMaximizedVal ? 'chevron-right' : 'chevron-left'" />
    </div>
  `,
  host: {
    '[class.minimized]': 'minimized()',
  },
  styleUrls: ['./main-navigation-toggle.component.less'],
  imports: [IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentMainNavigationToggleComponent {
  public minimized = input.required<boolean>();
  public forceMaximized = input.required<boolean>();
}
